module.exports = __webpack_public_path__ + "img/D3f809cq.bb434ffe.png";